exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".channel-logo {\r\n    width: 100px;\r\n    height: 40px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/OTHERS/FirstmediaShowSchedule/src/app/favorite-edit/favorite-edit.component.css
// module id = ../../../../../src/app/favorite-edit/favorite-edit.component.css
// module chunks = main